import React from 'react';
import { FiDatabase, FiUsers, FiCheckCircle, FiTrendingUp } from 'react-icons/fi';
import './StatsStrip.css';

const stats = [
  { icon: <FiDatabase />, label: 'Data Mining' },
  { icon: <FiUsers />, label: 'Businesses Served' },
  { icon: <FiCheckCircle />, label: 'Data Accuracy' },
  { icon: <FiTrendingUp />, label: 'Insights Delivered' },
];

const StatItem = ({ icon, label }) => {
  return (
    <div className="stat-item">
      <div className="stat-icon">{icon}</div>
      <span className="stat-label">{label}</span>
    </div>
  );
};

const StatsStrip = () => (
  <section className="stats-band">
    <div className="stats-container">
      {stats.map((s) => (
        <StatItem key={s.label} {...s} />
      ))}
    </div>
  </section>
);

export default StatsStrip;